<template>
	<div>
		<v-card flat color="transparent">
			<v-card-text>
				<v-row align="center">
					<v-col cols="12" md="3" lg="3" class="mx-0 px-0">
						<!-- <v-text-field v-model="tableProps.search" label="Buscar un banco" clearable prepend-inner-icon="mdi-magnify" hide-details></v-text-field> -->
                        <alternativeTextField2
                            @onChanged="(v) => {trySearch(v);}"
                            @onClear="(v) => {trySearch(v);}"
                            :valueInput="tableProps.search"
                            :rule="[]"
                            :placeholder="'Buscar'"
                            :label="''"
                            :clearable="true"
                            :prependInnerIcon="'mdi-magnify'"
                            class="pick-3"
                        ></alternativeTextField2>
					</v-col>
					<v-spacer></v-spacer>
					<v-col md="6" class="mx-0 ">
                        <v-row justify="end">
                            <iconButton class="mr-0 mr-md-2 mb-3 mb-md-0" :props="exportBtnData"></iconButton>
                            <iconButton v-permission="'providers.create'" class="" :props="createBtnData"></iconButton>
                        </v-row>
					</v-col>
				</v-row>
				<v-row>
                  
					<v-col class="mx-0 px-0">
						<datatable :options="options" :props="tableProps" @methodHandler="method_handler" @handleOptions="handleOptions">
                           
                            <template v-slot:[`item.is_visible`]="{ item }">
                                <v-row align="center" justify="center">
                                  
                                    <v-radio-group v-model="item.checked"  v-if="!item.loading">
                                        
                                        <v-radio
                                            v-on:click="updatePermission(item)"
                                            color="success"
                                            class="center-radio"
                                            :value="1"
                                        ></v-radio>             

                                    </v-radio-group>
                                    <v-progress-circular
                                        v-if="item.loading"
                                        indeterminate
                                        color="success"
                                        size="25"
                                    ></v-progress-circular>

                                   
                                </v-row>
                            </template> 
                        </datatable>
					</v-col>
				</v-row>
			</v-card-text>
		</v-card>

        <modal :props="modalProps" @modalResponse="method_handler">
			<!-- Buttons -->
			<template slot="cardActions">
				<v-row justify="end">
					<v-col cols="12" sm="4">
						<secondaryButton
						:props="cancelModal"
						></secondaryButton>
					</v-col>
					<v-col cols="12" sm="4">
						<primaryButton
						:props="acceptModal"
						></primaryButton>
					</v-col>
				</v-row>
			</template> 
		</modal>
		
	</div>
</template>
<script>
import PageStateManager from '../../../helpers/PageStateManager'
export default {
    data(){
		return {
            options: JSON.parse(PageStateManager.getState(this.$router.history.current.path, 'optionsIndexTable'))??{},
            selectedID: '',
            loadingExport: true,
			actions: [
				
				{
					name: 'Editar',
					icon: {
						color: 'secondary',
						icon: 'mdi-pencil-outline'
					},
					disabled: false,
					type: 'redirect',   //  method, external, redirect
					action: '',
                    permissions: 'providers.update'
				},
				{
					name: 'Borrar',
					icon: {
						color: 'secondary',
						icon: 'mdi-delete-outline'
					},
					disabled: false,
					type: 'method',   //  method, external, redirect
					action: 'deleteItemModal',
                    permissions: 'providers.delete'
				},
			],
			tableProps: {
				headers: [
                    {
						text: 'Proveedor',
						align: 'left',
						value: 'name',
						
						class: 'table-b-border black--text'
					},
					{
						text: 'Disponibilidad en esta empresa',
						align: 'center',
						value: 'is_visible',
						
						class: 'table-b-border black--text'
					},
                    // {
					// 	text: 'checked',
					// 	align: 'center',
					// 	value: 'checked',
						
					// 	class: 'table-b-border black--text'
					// },
                    // {
					// 	text: 'RFC',
					// 	align: 'left',
					// 	value: 'rfc',
					// 	class: 'table-b-border black--text'
					// },
                    // {
					// 	text: 'Origen',
					// 	align: 'left',
					// 	value: 'origin',
                        
					// 	class: 'table-b-border black--text'
					// },
                    // {
					// 	text: 'País',
					// 	align: 'left',
					// 	value: 'country_code',
                        
					// 	class: 'table-b-border black--text'
					// },
                    // {
					// 	text: 'Contacto',
					// 	align: 'left',
					// 	value: 'contact',
                        
					// 	class: 'table-b-border black--text'
					// },
                    // {
					// 	text: 'Estatus',
					// 	align: 'left',
					// 	value: 'status',
                        
					// 	class: 'table-b-border black--text'
					// },
					{
						text: 'Acciones',
						align: 'right',
						sortable: false,
						value: 'actions',
						width: '10%',
						class: 'table-b-border black--text'
					}
				],
				items: [],
				search: (JSON.parse(PageStateManager.getState(this.$router.history.current.path, 'optionsIndexTable')))?.search??"",
				loading: true
			},
			
			
            createBtnData: {
                hasTooltip:true,
                tooltip: 'Nuevo proveedor',
                color:'primary',
                iconColor:'grey darken-3',
                height:'35',
                icon: "mdi-plus",
				to: "SuppliersCreate",
				block: false,
                click: ()=>{}
            },
            exportBtnData: {
                hasTooltip:true,
                tooltip: 'Exportar excel',
                color:'primary',
                iconColor:'grey darken-3',
                height:'35',
                icon: "mdi-microsoft-excel",
                iconClass: "",
                loading: false,
				to: "",
				block: false,
                click: ()=>{this.tryGetReport()}
            },

			modalProps: {
				visible: false,
				width: '500',
				title: 'Eliminar',
				text: '¿Estás seguro de eliminar?',
				loading: false,
				bottomLineColor: 'error',
				
			},
			
			cancelModal: {
                text: "No, cancelar",
                icon: "",
				to: "",
				block: true,
				color: '',
                click: ()=>{this.modalProps.visible = false}
            },
			acceptModal: {
                text: "SI, ELIMINAR",
                icon: "",
				to: "",
				block: true,
				color: 'error',
				textColor:'white',
                textColorLevel: '0',
				loading:false,
                click: ()=>{this.delete()}
            },
		}
	},

	mounted(){
		this.index();
        window.addEventListener('resize', this.onResize, { passive: true });
        this.onResize();
	},

    methods: {
        method_handler(object){
            console.log(object);
			this[object.methodName](object.parameters)
		},
        onResize () {
            
            if(window.innerWidth < 960){
                this.createBtnData.block = true;
                // this.exportBtnData.block = true;
            }
            else{
                this.createBtnData.block = false;
                // this.exportBtnData.block = false;
            }
        },
      
        handleOptions(object){
            object.options[`search`] = this.tableProps.search;
			console.log(object.options, "optionss");
			this.options = object.options;
            PageStateManager.setState(this.$router.history.current.path, 'optionsIndexTable', JSON.stringify(this.options));
			// this.index();
		},
        trySearch(val){
            this.tableProps.search = val;
            this.options.search = val;
            this.options.page = 1;
            PageStateManager.setState(this.$router.history.current.path, 'optionsIndexTable', JSON.stringify(this.options));
            // this.index();
        },
		index() {
			this.tableProps.loading = true;
           
			//call api
			this.$api.supplier.permissionList(this.$store.state.business)
				.then((resp) =>{
					//console.log(resp);
					this.tableProps.items = resp.data.map((x) => {
						x['actions'] = JSON.parse(JSON.stringify(this.actions))
                       
						
						// x.actions[0].action = { name: '', params: { slug: x.slug } }
                        x.actions[0].action = { name: 'SuppliersEdit', params: { slug: x.slug } }
						

						x['parameters'] = { id: x.slug, name: x.name};
                        
						//x.status = x.status === 1 ? 'Activo' : 'Inactivo';
                        x.checked = x.is_visible ? 1 : 0;
                        x.loading = false;
						return x;
					});
				})
				.catch((error) =>{
					console.log(error);
				})
				.finally(() => {
					this.tableProps.loading = false;
				})
			;
		
		},

        tryGetReport()
        {
            this.exportBtnData.loading = true;
            this.$store.state.loading = true;
            this.$api.supplier.getReport(this.$store.state.business)
                .then((resp) => {
                    const fileURL = window.URL.createObjectURL(new Blob([resp.data]));
                    const fileLink = document.createElement("a");
                    fileLink.href = fileURL;
                    fileLink.setAttribute(
                    "download",
                    `proveedores_${this.$store.state.business}.xlsx`
                    );
                    document.body.appendChild(fileLink);
                    fileLink.click();
                })
                .catch((error) => {
                    console.log(error);
                })
                .finally(() => {
                    this.exportBtnData.loading = false;
                    this.$store.state.loading = false;
                })
            ;
        },

		deleteItemModal(parameters)
		{
			//console.log(parameters);
			this.selectedID = parameters.id;
			this.modalProps = {
				...this.modalProps,
				text: `¿Estás seguro de eliminar "${parameters.name}"?`,
				
			}
            console.log(this.selectedID)
			this.modalProps.visible = true;
			
		},


		delete()
		{
			//console.log(this.selectedID);
			this.acceptModal.loading = true;
			this.$api.supplier.delete(this.$store.state.business, this.selectedID)
			// eslint-disable-next-line
			.then((response) => {
				
				this.$store.dispatch('snackbarSuccess', `Se ha eliminado`);
				this.index()
				// eslint-disable-next-line
			}).catch(error => {
				if(error.response.status === 422){
                    this.$store.dispatch('snackbarError', `${error.response.data.error??'Error al eliminar'}`);
                }else{
                    this.$store.dispatch('snackbarError', `Error al eliminar. Intenta de nuevo`);
                }

				
			})
			.finally(() => {
				this.modalProps.visible = false;
				this.acceptModal.loading = false;
			})
		},


        updatePermission(item)
        {
            const pos = this.tableProps.items.map(function(e) { return e.slug; }).indexOf(item.slug);
          

            this.tableProps.items[pos].loading = true;
            this.$api.supplier.updatePermission(this.$store.state.business, item.slug)
			// eslint-disable-next-line
                .then(() => {
                    
                    this.tableProps.items[pos].is_visible = !this.tableProps.items[pos].is_visible;
                    this.tableProps.items[pos].checked = this.tableProps.items[pos].is_visible?1:0;
                   
                  
                    // eslint-disable-next-line
                }).catch(error => {
                    if(error.response.status === 422){
                        this.$store.dispatch('snackbarError', `${error.response.data.error??'Error al actualizar'}`);
                    }else{
                        this.$store.dispatch('snackbarError', `Error al Actualizar. Intenta de nuevo`);
                    }

                    
                })
                .finally(() => {
                    this.tableProps.items[pos].loading = false;
                })
            ;
        }

    }
}
</script>

<style lang="scss">
    .center-radio{
        justify-content: center !important;
    }
</style>